
import { useAddTaskMutation } from './mutations/useAddTaskMutation';
import { useEditTaskMutation } from './mutations/useEditTaskMutation';
import { useDeleteTaskMutation } from './mutations/useDeleteTaskMutation';
import { useCompleteTaskMutation } from './mutations/useCompleteTaskMutation';
import { useReactivateTaskMutation } from './mutations/useReactivateTaskMutation';

export const useTaskMutations = () => {
  const addTaskMutation = useAddTaskMutation();
  const editTaskMutation = useEditTaskMutation();
  const deleteTaskMutation = useDeleteTaskMutation();
  const completeTaskMutation = useCompleteTaskMutation();
  const reactivateTaskMutation = useReactivateTaskMutation();

  return {
    addTaskMutation,
    editTaskMutation,
    deleteTaskMutation,
    completeTaskMutation,
    reactivateTaskMutation,
  };
};
